import React, { useEffect } from "react";
import GiftItem from "./GiftItem";
import { Container } from "./styles";
import { Subtitle } from "../styles";
import { useNavigate } from "react-router-dom";
import { friendShopAPI } from "redux/apis/friendShop";
import { GiftSelectionSkeleton } from "./skeleton";

const GiftSelection = () => {
	const navigate = useNavigate();
	const { data, isLoading } =
		friendShopAPI.endpoints.getGiftsFriendShop.useQueryState(undefined);

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	}, []);

	const handleSelectGift = (giftIndex: number) => {
		navigate(`${giftIndex}/friends`);
	};

	if (isLoading) {
		return (
			<>
				<Subtitle> Send a Gift to a Friend</Subtitle>
				<GiftSelectionSkeleton />
			</>
		);
	}

	if (!data) {
		return null;
	}

	return (
		<>
			<Subtitle> Send a Gift to a Friend</Subtitle>
			<Container>
				{(data?.shopOffers ?? []).map((offer, index) => {
					return (
						<GiftItem
							key={offer.id}
							shopOffer={offer}
							onSelect={() => handleSelectGift(index)}
						/>
					);
				})}
			</Container>
		</>
	);
};

export default GiftSelection;
